import axios from 'axios';

class API{

  config(){
    return {
      baseURL: (process.env.VUE_APP_GIT_BRANCH == "uat" ? '/uat' : '') + process.env.VUE_APP_API_URL,
      timeout: 15000,
      headers: {
        'Content-Type': 'application/json'
      }
    }
  }

  onFulfilled(response){
    if(response.status==200){
      if(response.data.status=="ok"){
        return response.data.data;
      }else{
        console.warn('bad response status text', response.data.error);
        return Promise.reject(response.data.error);
      }
    }else{
      console.warn('bad response status code');
      return Promise.reject('bad response status code');
    }
  }

  onRejected(err){
    console.error('Failed to process a request for the data source',err);
    return Promise.reject(err.message);
  }

  generate(data){
    return axios.post('/generate.php', data, this.config())
      .then(this.onFulfilled,this.onRejected);
  }

  uploadFile(file){
    document.body.classList.add('fileUploading')
    const data = new FormData()
    data.append("file", file)

    return axios.post('/uploadFile.php', data, {
      ...this.config(),
      headers: {'Content-Type': 'multipart/form-data'}
    })
    .then(this.onFulfilled,this.onRejected)
    .finally(()=>{
      document.body.classList.remove('fileUploading')
    })
  }
  checkFile(url){
    return axios.head(url,{
      timeout:2000
    }).then(() => true).catch(() => false)
  }
}

export default new API()